import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { handleEvalTracking } from "../../helpers/tracking"

export class ItineraryContentBlockHeadlineButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox">
        <div className="grid">
          <div className="grid-item col--12 col-sm--12 left-align">
            <div className="textbuttoncontainer">
              <h5>{this.props.block.text}</h5>
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
